import React from 'react'
import GalleryHero from '../Gallery/GalleryHero'
import GallerySection from '../Gallery/GallerySection'
import Footer from '../Footer/Footer'

function Gallery() {
    return (
        <div>
           <GalleryHero/>
           <GallerySection/>
           <Footer/>
        </div>
    )
}

export default Gallery
